import { useState } from "react";
// @mui
import {
  Button,
  Grid,
  CircularProgress,
  Box,
  ImageListItem,
  ImageList,
  Dialog,
  DialogTitle,
  DialogContent,
  Avatar,
  DialogActions,
  ImageListItemBar,
} from "@mui/material";
import axios from "axios";
import { TEAMS } from "src/constants/teams";
import {
  createBlobInContainer,
  getBlobsInContainer,
} from "src/utils/azureBlob";
import Iconify from "../iconify";

// ----------------------------------------------------------------------
const isOlybet = process.env.REACT_APP_NAME === "olybet";
const getTeamId = (teamAbbr) => {
  let teamData = TEAMS.find((team) => team?.abbr === teamAbbr);
  return !teamData ? "0" : teamData.teamId;
};
export default function AssetsDialog(props) {
  const [loading, setLoading] = useState(false);
  const [showAssetsType, setShowAssetsType] = useState(null);
  const [teamPlayers, setTeamPlayers] = useState([]);
  const [imageLibraryFiles, setImageLibraryFiles] = useState([]);
  const onCancel = () => {
    setShowAssetsType(null);
    props.onClose();
  };
  const uploadFiles = async (event) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = event.target.files;
      try {
        const url = await createBlobInContainer(files[0]);
        setLoading(false);
        addAssetHandler(url);
      } catch (error) {
        console.error('Upload failed:', error);
        setLoading(false);
      }
    }
  };
  const addAssetHandler = (
    assetUrl,
    title = null,
    titleFr = null,
    jersey_number = null,
    teamId = null,
    playerId = null
  ) => {
    // Add jersey number and club name as description for Pepsi
    if (teamId !== null && showAssetsType === "players") {
      const teamData = TEAMS.find((team) => team.teamId == teamId);

      props.onSuccess(
        assetUrl,
        title,
        titleFr,
        teamData.teamName,
        teamData.teamNameFr,
        jersey_number,
        `https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${teamData.teamId}.svg`,
        teamData.teamId,
        playerId
      );
    } else {
      props.onSuccess(
        assetUrl,
        title,
        titleFr,
        null,
        null,
        null,
        null,
        teamId,
        playerId
      );
    }
  };
  const loadTeamPlayers = (teamAbbr) => {
    setLoading(true);
    console.log("teamId", teamAbbr);
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/hockey/tournament/1/teams?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        let data = response.data.squad.Teams.find(
          (team) => team.Abbr == teamAbbr
        );
        data.Players = data.Players.sort((p1, p2) =>
          p1.FirstName > p2.FirstName ? 1 : p1.FirstName < p2.FirstName ? -1 : 0
        );
        setTeamPlayers(data);

        setShowAssetsType("players");
        setLoading(false);
      });
  };
  const loadImageLibraryFiles = () => {
    setLoading(true);
    const fetchImages = async () => {
      const data = await getBlobsInContainer();
      setImageLibraryFiles(data);
      setShowAssetsType("image_library");
      setLoading(false);
    };

    fetchImages().catch(console.error);
  };

  const sortedTeams = TEAMS.sort((p1, p2) =>
    p1.teamName > p2.teamName ? 1 : p1.teamName < p2.teamName ? -1 : 0
  );

  console.log("teamPlayers", teamPlayers);
  return (
    <>
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Add Asset</DialogTitle>
        <DialogContent>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: "100px 200px" }}
            >
              <CircularProgress />
            </Box>
          ) : null}
          {showAssetsType === null && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {!isOlybet && (
                <>
                  <Grid
                    item
                    xs={3}
                    sx={{ cursor: "pointer", p: 2 }}
                    onClick={() => setShowAssetsType("teams")}
                  >
                    <Grid container>
                      <Grid item>
                        <Avatar
                          sx={{ width: 120, height: 120 }}
                          alt="Remy Sharp"
                          src="https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/2.svg"
                        />
                      </Grid>
                      <Grid
                        sx={{
                          fontSize: 14,
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        Team Logo
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={3} sx={{ cursor: "pointer", p: 1 }}>
                    <Grid container>
                      <Grid item>
                        <Avatar
                          sx={{ width: 100, height: 100, minHeight: 120 }}
                          alt="Remy Sharp"
                          src="https://assets.nhle.com/mugs/nhl/20242025/NYI/8470601.png"
                          onClick={() => setShowAssetsType("teams_players")}
                        />
                      </Grid>
                      <Grid
                        sx={{
                          fontSize: 14,
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        Player Headshot
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}

              <Grid item xs={3} sx={{ cursor: "pointer", p: 1 }}>
                <Grid container>
                  <Grid
                    xs={12}
                    item
                    sx={{
                      height: 120,
                      width: 120,
                      textAlign: "center",
                      p: 4,
                    }}
                  >
                    <img
                      alt="Remy Sharp"
                      src="/assets/icons/navbar/image-outline.svg"
                      onClick={() => loadImageLibraryFiles()}
                    />
                  </Grid>
                  <Grid
                    sx={{ fontSize: 14, textAlign: "center", width: "100%" }}
                  >
                    Image Library
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3} sx={{ cursor: "pointer", p: 1 }}>
                <Grid container>
                  <Grid
                    xs={12}
                    item
                    sx={{
                      height: 120,
                      width: 120,
                      textAlign: "center",
                      p: 4,
                    }}
                  >
                    <input
                      accept="image/*"
                      type="file"
                      id="select-icon"
                      style={{ display: "none" }}
                      onChange={async (e) => await uploadFiles(e)}
                    />
                    <label htmlFor="select-icon">
                      <Iconify
                        icon="eva:plus-circle-outline"
                        sx={{
                          width: 20,
                          height: 20,
                          cursor: "pointer",
                          marginTop: 2,
                          marginBottom: 2,
                        }}
                      />
                    </label>
                  </Grid>
                  <Grid
                    sx={{ fontSize: 14, textAlign: "center", width: "100%" }}
                  >
                    Upload Image
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : null}
          {showAssetsType === "teams" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {sortedTeams.map((team) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    addAssetHandler(
                      `https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${team.teamId}.svg`,
                      team.teamName,
                      team.teamNameFr,
                      null,
                      team.teamId
                    )
                  }
                >
                  <Avatar
                    sx={{ margin: "0 auto" }}
                    alt="Remy Sharp"
                    src={`https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${team.teamId}.svg`}
                  />
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {team.teamName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "teams_players" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {sortedTeams.map((team) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                  onClick={() => loadTeamPlayers(team?.abbr)}
                >
                  <Avatar
                    sx={{ margin: "0 auto" }}
                    alt="Remy Sharp"
                    src={`https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${team.teamId}.svg`}
                  />
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {team.teamName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "players" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              {teamPlayers.Players.map((player) => (
                <Grid
                  item
                  xs={2}
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    addAssetHandler(
                      `https://assets.nhle.com/mugs/nhl/20242025/${teamPlayers.Abbr}/${player.PlayerFeedId}.png`,
                      `${player.FirstName} ${player.LastName}`,
                      `${player.FirstName} ${player.LastName}`,
                      player.jersey_num,
                      getTeamId(teamPlayers.Abbr),
                      player.PlayerFeedId
                    )
                  }
                >
                  <Avatar
                    sx={{ margin: "0 auto" }}
                    alt="Remy Sharp"
                    src={`https://assets.nhle.com/mugs/nhl/20242025/${teamPlayers.Abbr}/${player.PlayerFeedId}.png`}
                  />
                  <Box
                    sx={{
                      fontSize: 8,
                      pl: 2,
                      pr: 2,
                      pb: 1,
                      textAlign: "center",
                    }}
                  >
                    {player.FirstName} {player.LastName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : null}
          {showAssetsType === "image_library" && !loading ? (
            <Grid container sx={{ minWidth: 400 }}>
              <ImageList cols={3}>
                {imageLibraryFiles.map((item, index) => (
                  <ImageListItem
                    key={index}
                    onClick={() => addAssetHandler(item.blobUrl)}
                    sx={{ cursor: "pointer" }}
                  >
                    <img
                      src={item.blobUrl}
                      srcSet={item.blobUrl}
                      alt="library"
                      loading="lazy"
                    />
                    <ImageListItemBar title={item.blobName} subtitle={""} />
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
